import React, { useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'

import { LOGIN } from 'settings/_routesSettings'

import { SignupContext } from 'contexts/SignupContext'

import Logo from 'components/Logo'
import Row from 'components/Row'
import { Column, Container } from 'components'

import { stepsList } from './Steps/Steps'

import { Typography, useDimensions } from '@telavita-core/react-design-kit'

const Register = ({
  children,
  showStepper,
  showLoginInfo,
  currentStep,
}) => {

  const { planGroup } = useContext(SignupContext)
  const { isMobile } = useDimensions()
  
  const hasPlanCode = !!planGroup.code
  const currentStepIndex = getCurrentStepIndex(currentStep, hasPlanCode)
  const totalStepsIndex = getTotalSteps(hasPlanCode)

  const captcha = document.querySelector('.grecaptcha-badge')
  
  useEffect(() => {
    if(captcha) {
      captcha.style.opacity = '1'
      if(isMobile) captcha.style.position = 'relative'
    }
    return () => {
      if(captcha) {
        captcha.style.opacity = '0'
        if(isMobile) captcha.style.position = 'initial'
      }
    }

    //eslint-disable-next-line
  }, [captcha])

  function getCurrentStepIndex(currentStep, isPlanGroup) {
    let currentIndex = 0

    switch (currentStep) {
    case stepsList.GROUP_SELECTION:
      currentIndex = 1
      break
    case stepsList.INFO_GROUP:
      currentIndex = 2
      break
    case stepsList.INFO_PERSONAL:
      currentIndex = isPlanGroup ? 3 : 2
      break
    case stepsList.PHONE_CHECK:
      currentIndex = isPlanGroup ? 4 : 3
      break
    default:
      currentIndex = 0
      break
    }

    return currentIndex
  }

  function getTotalSteps(isPlanGroup) {
    return isPlanGroup ? 4 : 3
  }

  return (
    <Container>
      <Row justify="center" className="Register__Header">
        <Column align="center" justify="center" colWidth={4}>
          <Column style={{ textAlign: 'center' }}>
            <Logo
              fill="#1f35b5"
              onClickLogo={() => window.location.href = process.env.REACT_APP_INSTITUTIONAL_URL}
            />
          </Column>
        </Column>
      </Row>
      <Row justify="center" margin="30px 0">
        <Column colWidth={4}>
          <>
            <Row justify="center">
              <Typography 
                variant="header1"
                center
                inlineStyles={{ 
                  fontSize: '30px',
                  lineHeight: '2.1rem'
                }}
              >
                Criar conta
              </Typography>
            </Row>
            {
              showStepper &&
              <Row justify="center" margin="5px 0 0">
                <Typography 
                  center
                  variant="content3"
                  color='primary'
                  weight='bolder'
                  inlineStyles={{ lineHeight: '2.1rem' }}
                >
                  PASSO {currentStepIndex} DE {totalStepsIndex}
                </Typography>
              </Row>
            }
            <Row justify="center" margin="30px 0">
              <div className="StepperProgress">
                <Row justify="center" margin="0">
                  {children}
                </Row>
              </div>
            </Row>
            {
              showLoginInfo &&
              <Row margin="30px 0 0" justify="center">
                <Typography
                  center
                  variant="content2"
                >
                  Já tem conta? É só
                  <Link to={LOGIN} className='Register__Link'>
                    entrar
                  </Link>
                </Typography>
              </Row>
            }
          </>
          <div className="Register__Professionals">
            <div />
            <p className="Register__Professionals__Text">
              A criação de conta é <b>exclusiva para pacientes.</b> <br/>
              Se você é profissional e quer atender na Telavita, <a href='https://conteudo.telavita.com.br/quero-fazer-parte'><b>saiba mais.</b></a>
            </p>
          </div>
        </Column>
      </Row>
    </Container>
  )
}

export default Register